<template>
 <div id="review-order-update-txt-loading" class="vs-con-loading__container">

<vs-card v-if="FTP==1">
    <vs-row>
      <vs-col style="margin-left:3em;margin-top:3px">
        <h4>
          Evidence
        </h4>
      </vs-col>
    </vs-row>
    <vs-row >
      <vs-col vs-w="6" vs-xs="12">
        <vs-col vs-w="12">
          <qb-upload textSize="18" text="Upload .txt" ref="upload" :showUploadButton="false" 
          @on-delete="handleEvidenceDelete" limit="1" :reset="resetTxt" @update-file="handleEvidenceUpdate" accept="text/plain" />
        </vs-col>
      </vs-col>
      <vs-col vs-w="6" vs-xs="12">
        <vs-col vs-w="12">
          <qb-upload ref="upload"  textSize="18" text="Upload .pdf" :showUploadButton="false" 
          @on-delete="handleEvidenceDelete" limit="1" :reset="resetPdf" @update-file="handleEvidenceUpdate" accept="application/pdf" />
        </vs-col>
      </vs-col>
    </vs-row>
</vs-card>

    <review-order-import v-model="invoicesFile" 
    :showCheckbox="false" :disabled="isLoading" 
    :showUploadFile="invoicesFile.tables.length == 0"
    :showCreationDate="false"
    />
    <vs-row style="margin-top: 2em" type="flex" vs-justify-content="space-between" :style="{display:'flex-inline'}">
      <vs-col vs-lg="3" vs-xs="5">
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="w-full"
          @click="$router.push('/review_orders/'+$route.params.id)"
        >
         Cancelar
        </vs-button>
      </vs-col>
      <vs-col vs-lg="6"  vs-xs="2">
            &nbsp;
      </vs-col>
      <vs-col vs-lg="3"  vs-xs="5">
        <vs-button
          icon-pack="feather"
          icon="icon-check"
          class="w-full"
          @click="showValidationsBack" 
          :disabled="disabledValidateButton"
        > <!-- "showValidationsBack" --> <!-- disabledValidateButton -->
          Validar Archivo .txt
        </vs-button>
      </vs-col>
    </vs-row>

    <vs-popup
      :title="$t('update') + ' .Txt'"
      :active.sync="activeValidationFile"
    >
      <vs-row>
        <div v-if="TxtErrors && errorsSameInfo.length == 0">
          <vs-avatar color="success" icon="check" class="custom-icon" />
          Archivo sin errores de Validación.
          <!-- Attach complement files -->
         

          <!--  -->
        </div>
        <div v-else style="color: red">
          <div class="vx-row text-center validations-list">
          <div class="vx-col w-full" v-for="(error, i) in validationErrors" :key="i">
            <div class="div-validation-list" v-for="(e, j) in error" :key="'A' + j">
              <vs-avatar color="danger" icon="close" class="custom-icon icon-validation-list" />
              <span class="f-12 text-validation-list">{{ e }}</span>
            </div>
          </div>
        </div>
          <div v-if="errorsSameInfo.length != 0">
          <vs-table :data="errorsSameInfo">
            <template slot="thead">
              <vs-th>Diferencias encontradas</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">                 
                <vs-td>{{row[0]}}</vs-td>
                <template slot="expand">
                   <vs-table :data="row[1]">
                      <template slot="thead">
                        <vs-th></vs-th>
                        <vs-th>System</vs-th>
                        <vs-th>Invoice</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">                 
                          <vs-td>{{tr[0]}}</vs-td>
                          <vs-td>{{tr[2]}}</vs-td>
                          <vs-td>{{tr[1]}}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                </template>
              </vs-tr>
            </template>
          </vs-table>
          </div>
        </div>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end">
        <vs-col vs-w="4">
          <vs-button @click="activeValidationFile = false"
          :disabled="isLoading">{{$t('go_back')|capitalize}}</vs-button>
        </vs-col>
        <vs-col vs-w="4">
          <vs-button
            @click="confirmUpdateTxt"
            :disabled="!TxtErrors || errorsSameInfo.length != 0 || isLoading"
            color="success"
          >
            {{$t('upload_file')|capitalize}}
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import ReviewOrderImport from '@/views/modules/import_export/review_order/components/ReviewOrderImport'
import reviewOrder from '@/http/requests/reviewOrder'
import general from '@/http/requests/general'
import loading from '@/mixins/Loading'
import QbUpload from '@/components/upload/QbUpload.vue'

export default {
  components: {
    ReviewOrderImport,
    QbUpload
  },
  computed:{
      disabledValidateButton(){
        let files=false
        if(this.FTP=='1'){
          files = (this.filesFTP.pdf=='' || this.filesFTP.txt=='')
        }
        return this.invoicesFile.tables.length == 0 || this.errorsSameInfo.length>0 || files
      },
      fileDisabled(){
          return !(this.ro_loaded && this.invoices_loaded && this.invoicesFile.tables.length == 0)
      },
      isLoading () {
        return (
          this.loading.ro ||
          this.loading.invoices ||
          this.loading.validations ||
          this.loading.check_setting
        )
      }
  },
  mixins: [loading],
  watch:{
      submitForm(){
          if(this.submitForm){
              this.$router.push('/review_orders/'+this.ro.id).catch(() => {})
          }
      },
      isLoading (val) {
        if (val) {
          this.openLoading('review-order-update-txt-loading')
        } else {
          this.closeLoading('review-order-update-txt-loading')
        }
      },
      invoicesFile(){
        if(this.invoicesFile.tables.length>0){
          this.showValidations()
        }
      }
  },
  data() {
    return {
      FTP:'0',
      filesFTP: {
        pdf:'',
        txt:''
      },
      invoicepdf:'',
      invoicetxt:'',
      invoices:[],
      invoicesFile: {
        tables: []
      },
      loading:{
        ro:false,
        invoices:false,
        validations:false,
        check_setting:false
      },
      ro:[],
      ro_id: this.$route.params.id,
      ro_loaded: false,
      resetPdf:false,
      resetTxt:false,
      invoices_loaded: false,
      TxtErrors: true,
      submitForm: false,
      validationErrors: [],
      activeValidationFile: false,
      errorsSameInfo: [],
      tmp_invoices: []
    }
  },
  mounted() {
    this.getInvoices()
    this.getROinfo()
    this.checkSettingFTP()
  },
  methods: {
    checkSettingFTP(){
      this.loading.check_setting=true
      general.checkSetting('UPLOAD_FTP_WAREHOUSE').then(res => {
        console.log(res.data.value);
        this.FTP=res.data.value
        this.loading.check_setting=false
      }).catch(err => {
        this.loading.check_setting=false
      })
    },
    handleEvidenceDelete(e){
      if(e.type==='application/pdf'){
        this.filesFTP.pdf=''
      }
      if(e.type==='text/plain'){
        this.filesFTP.txt=''
      }
    },
    handleEvidenceUpdate(e){
        if (e[0].type === 'application/pdf') {
          if(this.filesFTP.pdf  != ''){
            this.resetTxt=!this.resetTxt
            this.filesFTP.txt='' 
          }else{
            this.filesFTP.pdf = e[0]
            this.getBase64(e[0],'pdf')
          }
        }else if (e[0].type === 'text/plain') {
          if(this.filesFTP.txt != ''){
            this.resetPdf=!this.resetPdf
            this.filesFTP.pdf='' 
          }else{
            this.filesFTP.txt = e[0]
            this.getBase64(e[0],'txt')
          }
          //codfiicar antes de mandar, y te manda caneda
          //"[object object]" decodicficar en back
          //convetir b64 antes de mandar a back
        }else{
          this.resetPdf=!this.resetPdf
          this.resetTxt=!this.resetTxt
          this.filesFTP.pdf=''
          this.filesFTP.txt=''
        }
    },
    getInvoices() {
      this.loading.invoices=true
      reviewOrder
        .reviewGetInvoices(this.$route.params.id)
        .then(res => {
          this.invoices_loaded=true
          this.loading.invoices=false
          this.invoices = [...res.data.items]
          this.tmp_invoices = [...res.data.tmps]
          let tmps=[]
          this.invoices.forEach(el => {
            tmps=this.filterTmps(this.tmp_invoices,el.id)
            if(tmps.length>0){
              el.tmps_fields=tmps[0].fields
            }else{
              el.tmps_fields={}
            }
          })
        })
        .catch(err => { })
    },
    filterTmps(data,invoice_id){
        return data.filter((item) => {
          return (parseInt(item.invoice_id)==parseInt(invoice_id))
        });
    },
    getROinfo(){
      this.loading.ro=true
        reviewOrder
        .reviewDetails(this.$route.params.id)
        .then(res => {
          this.ro = Object.assign({}, res.data.item)
          this.loading.ro=false
          this.ro_loaded=true
        })
        .catch(err => {})
    },
    showValidations() {
      let error=[]
      let errorList=[]
      this.errorsSameInfo = errorList
        let params = {
            invoice_items: this.invoicesFile.tables.map(table => table.json),
            validation: true
        }
        if(parseInt(this.ro.status_id) == 6){
                let merge_invoices = []
                let indice=0;
                this.invoices.forEach((item, index) => {
                  if(item.check!='2'){
                    indice=merge_invoices.length
                    merge_invoices[indice] = item.fields

                    if (item.tmps_fields['Folio Factura']) { merge_invoices[indice]['Folio Factura'] = item.tmps_fields['Folio Factura'] }
                    if (item.tmps_fields['Bultos (Bundles)']) { merge_invoices[indice]['Bultos (Bundles)'] = item.tmps_fields['Bultos (Bundles)'] }
                    if (item.tmps_fields['Clave de pedimento']) { merge_invoices[indice]['Clave de pedimento'] = item.tmps_fields['Clave de pedimento'] }
                    if (item.tmps_fields['No. parte']) { merge_invoices[indice]['No. parte'] = item.tmps_fields['No. parte'] }
                    if (item.tmps_fields['Descripcion']) { merge_invoices[indice]['Descripcion'] = item.tmps_fields['Descripcion'] }
                    if (item.tmps_fields['Descripcion en ingles']) { merge_invoices[indice]['Descripcion en ingles'] = item.tmps_fields['Descripcion en ingles'] }
                    if (item.tmps_fields['Cantidad']) { merge_invoices[indice]['Cantidad'] = item.tmps_fields['Cantidad'] }
                    if (item.tmps_fields['Unidad medida']) { merge_invoices[indice]['Unidad medida'] = item.tmps_fields['Unidad medida'] }
                    if (item.tmps_fields['Unidad medida tarifa']) { merge_invoices[indice]['Unidad medida tarifa'] = item.tmps_fields['Unidad medida tarifa'] }
                    if (item.tmps_fields['Factor de conversion']) { merge_invoices[indice]['Factor de conversion'] = item.tmps_fields['Factor de conversion'] }
                    if (item.tmps_fields['WareHouse']) { merge_invoices[indice]['WareHouse'] = item.tmps_fields['WareHouse'] }
                    if (item.tmps_fields['Pais de origen']) { merge_invoices[indice]['Pais de origen'] = item.tmps_fields['Pais de origen'] }
                    if (item.tmps_fields['Peso KG']) { merge_invoices[indice]['Peso KG'] = item.tmps_fields['Peso KG'] }
                    if (item.tmps_fields['Peso LB']) { merge_invoices[indice]['Peso LB'] = item.tmps_fields['Peso LB'] }
                    if (item.tmps_fields['V. Unit. Compra']) { merge_invoices[indice]['V. Unit. Compra'] = item.tmps_fields['V. Unit. Compra'] }
                    if (item.tmps_fields['V. Unit. Comercial']) { merge_invoices[indice]['V. Unit. Comercial'] = item.tmps_fields['V. Unit. Comercial'] }
                    if (item.tmps_fields['Valor Total USD']) { merge_invoices[indice]['Valor Total USD'] = item.tmps_fields['Valor Total USD'] }
                    if (item.tmps_fields['Marca']) { merge_invoices[indice]['Marca'] = item.tmps_fields['Marca'] }
                    if (item.tmps_fields['Modelo']) { merge_invoices[indice]['Modelo'] = item.tmps_fields['Modelo'] }
                    if (item.tmps_fields['Serie']) { merge_invoices[indice]['Serie'] = item.tmps_fields['Serie'] }

                    if (!merge_invoices[indice]['Marca']) { merge_invoices[indice]['Marca'] = "" }
                    if (!merge_invoices[indice]['Modelo']) { merge_invoices[indice]['Modelo'] = "" }
                    if (!merge_invoices[indice]['Serie']) { merge_invoices[indice]['Serie'] = "" }
                    
                  }
                });
            this.isTheSameInfo(merge_invoices,params.invoice_items[0])
        }
        
          if (this.invoices[0].fields['Folio Factura'] != params.invoice_items[0][0]['Folio Factura']) {
            error[0] = ['Folio Factura',params.invoice_items[0][0]['Folio Factura'],this.invoices[0].fields['Folio Factura']]
            errorList.push(['FOLIO NO COINCIDE: ',error])
          }
          //No repetir No.Parte con Warehouse3
          let tocheck=params.invoice_items[0]
          let compare=''
          let check_duplicate=true
          tocheck.forEach((item,key) => {
            compare=item['No. parte']+'|'+item['WareHouse']
            tocheck.forEach((element,index) => {
              error=[]
              if(element['No. parte']+'|'+element['WareHouse']==compare && index!=key && check_duplicate){
                error[error.length] = ['No. parte y WareHouse Duplicado',element['No. parte']+'|'+element['WareHouse'],compare]
                errorList.push(['No.Parte y WareHouse: ',error])
                check_duplicate=false
              }
            })
          })
          if(errorList.length>0){
            this.errorsSameInfo = errorList
          }

          if(this.errorsSameInfo.length!=0){
            let index = this.invoicesFile.tables.length - 1
            this.invoicesFile.tables.splice(index, 1);
            this.activeValidationFile=true
          }
    },
    getBase64(file,extension) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        //save on component variable
        if(extension=='pdf'){
          this.invoicepdf=reader.result
          console.log(this.invoicepdf);
        }
        if(extension=='txt'){
          this.invoicetxt=reader.result
          console.log(this.invoicetxt);
        }
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
    showValidationsBack(){
      this.loading.validations=true
      let params = {
            invoice_items: this.invoicesFile.tables.map(table => table.json),
            validation: true
        }
      reviewOrder.validateUpdateTxtFile(params).then(res => {
        this.loading.validations=false
        this.TxtErrors = res.data.status
        this.validationErrors = res.data.errors
        this.activeValidationFile = true
      }).catch(err => {
        this.loading.validations=false
        console.log(err)
      })
    },
    confirmUpdateTxt() {
      this.loading.validations=true
      this.activeValidationFile = false

      let params = {
          invoice_items: this.invoicesFile.tables.map(table => table.json),
          validation: false,
          ro_id: this.$route.params.id,
        }

        let data = new FormData()

        data.append('ro_id',this.$route.params.id)
        data.append('invoicepdf',this.filesFTP.pdf)
        data.append('invoicetxt',this.filesFTP.txt)

     
      reviewOrder.validateUpdateTxtFile(params).then(res => {
        if(res.data.status==true){
          if(this.FTP == '1'){
            reviewOrder.uploadFtpFiles(data).then(res => {
              console.log(res.data)
              this.submitForm=true
              this.loading.validations=false
              this.$vs.notify({
                color: 'success',
                title: 'Success',
                text: 'Orden de Revisión Actualizada'
              })
            })
          }else{
            this.submitForm=true
              this.loading.validations=false
              this.$vs.notify({
                color: 'success',
                title: 'Success',
                text: 'Orden de Revisión Actualizada'
              })
          }
        }
      }).catch(err => {
        this.activeValidationFile = true
        this.loading.validations=false
        console.log(err)
      })
    },
    isTheSameInfo(merged, to_send) {
      this.errorsSameInfo=[]
      let sameInfo = true;
      let errorList=[];
      let error = [];
      if (merged.length != to_send.length) {
        sameInfo = false;
        error[error.length] = ['Distinta longitud',to_send.length,merged.length]
        errorList.push(['Longitud Invoice',error])
        this.errorsSameInfo = errorList
      }
      if (merged.length > 0 && sameInfo) {
        merged.forEach((item, index) => {
          error=[];
          //si ya hay comparalo, si algun campo es dintinto mandar error
          if (to_send[index]['Folio Factura'] != item['Folio Factura']) {
            sameInfo = false
            error[error.length] = ['Folio Factura',to_send[index]['Folio Factura'],item['Folio Factura']]
          }
          if (to_send[index]['Bultos (Bundles)'] != item['Bultos (Bundles)']) {
            sameInfo = false
            error[error.length] = ['Bultos (Bundles)',to_send[index]['Bultos (Bundles)'],item['Bultos (Bundles)']]
          }
          if (to_send[index]['Clave de pedimento'] != item['Clave de pedimento']) {
            sameInfo = false
            error[error.length] = ['Clave de pedimento',to_send[index]['Clave de pedimento'],item['Clave de pedimento']]
          }
          if (to_send[index]['No. parte'] != item['No. parte']) {
            sameInfo = false
            error[error.length] = ['No. parte',to_send[index]['No. parte'],item['No. parte']]
          }
          if (to_send[index]['Descripcion'] != item['Descripcion']) {
            sameInfo = false
            error[error.length] = ['Descripcion',to_send[index]['Descripcion'],item['Descripcion']]
          }
          if (to_send[index]['Descripcion en ingles'] != item['Descripcion en ingles']) {
            sameInfo = false
            error[error.length] = ['Descripcion en ingles',to_send[index]['Descripcion en ingles'],item['Descripcion en ingles']]
          }
          if (parseInt(to_send[index]['Cantidad']) != parseInt(item['Cantidad'])) {
            sameInfo = false
            error[error.length] = ['Cantidad',to_send[index]['Cantidad'],item['Cantidad']]
          }
          if (to_send[index]['Unidad medida'] != item['Unidad medida']) {
            sameInfo = false
            error[error.length] = ['Unidad medida',to_send[index]['Unidad medida'],item['Unidad medida']]
          }
          if (to_send[index]['Unidad medida tarifa'] != item['Unidad medida tarifa']) {
            sameInfo = false
            error[error.length] = ['Unidad medida tarifa',to_send[index]['Unidad medida tarifa'],item['Unidad medida tarifa']]
          }
          if (Number(to_send[index]['Factor de conversion']) != Number(item['Factor de conversion'])) {
            sameInfo = false
            error[error.length] = ['Factor de conversion',to_send[index]['Factor de conversion'],item['Factor de conversion']]
          }
          if (to_send[index]['WareHouse'] != item['WareHouse']) {
            sameInfo = false
            error[error.length] = ['WareHouse',to_send[index]['WareHouse'],item['WareHouse']]
          }
          if (to_send[index]['Pais de origen'] != item['Pais de origen']) {
            sameInfo = false
            error[error.length] = ['Pais de origen',to_send[index]['Pais de origen'],item['Pais de origen']]
          }
          if (to_send[index]['Peso KG'] != item['Peso KG']) {
            sameInfo = false
            error[error.length] = ['Peso KG',to_send[index]['Peso KG'],item['Peso KG']]
          }
          if (to_send[index]['Peso LB'] != item['Peso LB']) {
            sameInfo = false
            error[error.length] = ['Peso LB',to_send[index]['Peso LB'],item['Peso LB']]
          }
          if (to_send[index]['V. Unit. Compra'] != item['V. Unit. Compra']) {
            sameInfo = false
            error[error.length] = ['V. Unit. Compra',to_send[index]['V. Unit. Compra'],item['V. Unit. Compra']]
          }
          if (to_send[index]['V. Unit. Comercial'] != item['V. Unit. Comercial']) {
            sameInfo = false
            error[error.length] = ['V. Unit. Comercial',to_send[index]['V. Unit. Comercial'],item['V. Unit. Comercial']]
          }
          if (to_send[index]['Valor Total USD'] != item['Valor Total USD']) {
            sameInfo = false
            error[error.length] = ['Valor Total USD',to_send[index]['Valor Total USD'],item['Valor Total USD']]
          }
          if (to_send[index]['Marca'] != item['Marca']) {
            sameInfo = false
            error[error.length] = ['Marca',to_send[index]['Marca'],item['Marca']]
          }
          if (to_send[index]['Modelo'] != item['Modelo']) {
            sameInfo = false
            error[error.length] = ['Modelo',to_send[index]['Modelo'],item['Modelo']]
          }
          if (to_send[index]['Serie'] != item['Serie']) {
            sameInfo = false
            error[error.length] = ['Serie',to_send[index]['Serie'],item['Serie']]
          }
          if(error.length>0){
            errorList.push(['No. Parte: '+item['No. parte'],error])
          }
        });
        this.errorsSameInfo = errorList
      }
      return sameInfo
    }
  },
}
</script>

<style lang="scss">
.custom-icon {
  width: 16px;
  height: 16px;
  top: 20%;
  .material-icons {
    font-size: 14px;
  }
}


.div-validation-list {
  display: inline-block;
  padding: 5px
}

.text-validation-list{
  clear: left;
  text-align: right;
  vertical-align: middle;
  line-height:25px;
}

.icon-validation-list
{
  display:inline-block;
  vertical-align:top;
}
</style>